import * as types from "./types";
import { getEventData } from "../../../screens/shared-event/requests/shared-event";

const fetchEventDataRequest = () => ({
  type: types.FETCH_SHARED_EVENT_DATA_REQUEST,
});

const fetchEventDataSuccess = (eventData) => ({
  type: types.FETCH_SHARED_EVENT_DATA_SUCCESS,
  payload: eventData,
});

const fetchEventDataFailure = (error) => ({
  type: types.FETCH_SHARED_EVENT_DATA_FAILURE,
  error,
});

export const fetchEventData = (hash) => async (dispatch) => {
  dispatch(fetchEventDataRequest());

  getEventData(hash)
    .then((res) => {
      if (res.status === 200) {
        dispatch(fetchEventDataSuccess(res.data.data));
      } else {
        throw new Error("API Error");
      }
    })
    .catch((error) => {
      dispatch(fetchEventDataFailure(error.message));
    });
};
